import type { SchoolCode } from '../api/axios';

function normalizeKnownSchool(school: SchoolCode | string | null | undefined): 'KBA' | 'TLC' | null {
  const value = String(school ?? '').trim().toUpperCase();
  if (value === 'KBA' || value === 'TLC') return value;
  return null;
}

/** Max numeric class level stored for the school (TLC Std 1–8 → 1–8, KBA Form 1–4 → 1–4). */
export function getMaxClassLevel(school: SchoolCode | string): number {
  const normalized = normalizeKnownSchool(school);
  if (normalized === 'TLC') return 8;
  return 4;
}

/**
 * Class-level noun for the school.
 * KBA (secondary) → "Form"; TLC (primary) → "Standard".
 */
export function classLevelWord(
  school: SchoolCode | string | null | undefined,
  style: 'long' | 'short' = 'long'
): string {
  const normalized = normalizeKnownSchool(school);
  if (normalized === 'TLC') return style === 'short' ? 'Std' : 'Standard';
  if (normalized === 'KBA') return 'Form';
  return style === 'short' ? 'Class' : 'Class';
}

/**
 * Human label for a numeric class level.
 * KBA → "Form 1"…; TLC → "Std 1"… (use style: 'long' for "Standard 1").
 */
export function formatClassLevelLabel(
  school: SchoolCode | string | null | undefined,
  level: number | null | undefined,
  style: 'long' | 'short' = 'short'
): string {
  if (level == null || Number.isNaN(level) || level < 1) return '—';
  const word = classLevelWord(school, style);
  return `${word} ${level}`;
}
